export const NAME = 'analyticData'
